export default "__VITE_ASSET__BCi6k$4S__"